module.exports = __webpack_public_path__ + "static/media/18.cffa1d8b.jpg";